export default "__VITE_ASSET__CWjMcMoa__"